import { render, staticRenderFns } from "./StepTwo.vue?vue&type=template&id=b0f9ed04&scoped=true&"
import script from "./StepTwo.vue?vue&type=script&lang=js&"
export * from "./StepTwo.vue?vue&type=script&lang=js&"
import style0 from "./StepTwo.vue?vue&type=style&index=0&id=b0f9ed04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f9ed04",
  null
  
)

export default component.exports